module.exports = __webpack_public_path__ + "static/media/Follower_Button-5.196904c5.png";